const numberFilterTypes = (locale) => ([
  { text: locale.get('dataComponents.equals'), value: 'equals' },
  { text: locale.get('dataComponents.isLessThan'), value: 'lessThan' },
  { text: locale.get('dataComponents.isGreaterThan'), value: 'greaterThan' },
  { text: locale.get('dataComponents.between'), value: 'between' }
]);

export default numberFilterTypes;
